import React from "react";
import { NavigationHelper } from "../helpers";

export const ScreensPage: React.FC = () => {
  React.useEffect(() => { setTimeout(NavigationHelper.showMobileSidebar, 10) }, []) // eslint-disable-line

  return (
    <>
      <h1><i className="fas fa-tv"></i> Screens</h1>
      <p>Select a screen on the left or create a new one.</p>
    </>
  );
};